/**
 * created by lei lei
 *系统检测
 */
import React from 'react';
import {Button, DatePicker, Divider, Input, Pagination, Select,} from "antd";
import {message} from "../../../sysManagement/utils/sysManagementUtils";
import * as utils from "../../../../utils";
import CustomTable, {TitleIcon} from "../../../components/customTable/CustomTable";
import './ContentSecurity.css';
import {Scrollbars} from "react-custom-scrollbars";
import * as Action from '../../actions/horizontalManagement';
import WeChatReview from "../../../components/weChatReview/WeChatReview";
import MicroBlogReview from "../../../components/microBlogReview/MicroBlogReview";
import TiktokReview from "../../../components/tiktokReview/TiktokReview";
import $ from "jquery";
import BaseComponent from "../../../../base/BaseComponent";

const {RangePicker} = DatePicker;
const dateFormat = 'YYYY-MM-DD';
const {Option} = Select;
const {Search} = Input;
export default class SystemDetection extends BaseComponent {

    constructor(props) {
        super(props);
        this.Action = Action;
        this.state = {
            startDate: null,//开始时间
            endDate: null,//结束时间
            depart: undefined,//所属部门
            mediaType: undefined, //媒体类型
            searchText: '',//搜索的文字
            page: 1,
            size: 10,
            dataSource: [],
            totalElements: 0,
            departAllList: [],
            hideOnSinglePage: true
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
        this.getSystemSensitiveCheckListQuery();//获取内容列表
        this.Action.getDeptAll((data) => {
            let departAllList = [];
            if (data && data.length > 0) {
                departAllList = data;
            }
            this.setState({
                departAllList
            })
        })
    }


    render() {
        return (
            <div className={'SystemDetection'}>
                {this.renderScreen()}
                {this.renderContent()}
                {/*// 微信预览*/}
                <WeChatReview ref={(WeChatReview) => {
                    this.WeChatReview = WeChatReview
                }}/>
                {/*微博预览*/}
                <MicroBlogReview ref={(MicroBlogReview) => {
                    this.MicroBlogReview = MicroBlogReview
                }}/>
                {/*抖音预览*/}
                <TiktokReview ref={(TiktokReview) => {
                    this.TiktokReview = TiktokReview
                }}/>
            </div>
        )
    }

    //渲染筛选条件
    renderScreen() {
        return (
            <div style={{padding: "10px 20px 0px 20px"}}>
                <div style={{float: 'left'}}>
                    <div style={{float: 'left'}}>
                        <div className={'ContenSecurityTitle'} style={{float: 'left'}}>监测时间</div>
                        <div style={{float: 'left', width: 210, marginTop: 6}}>
                            <RangePicker
                                value={[this.state.startDate, this.state.endDate]}
                                format={dateFormat}
                                onChange={(date, dateString) => {
                                    this.state.startDate = date[0];
                                    this.state.endDate = date[1];
                                    this.TypeChange();
                                }}
                            />
                        </div>
                    </div>
                    <div style={{float: 'left', paddingLeft: 10, display: "flex", alignItems: "center"}}>
                        <div className={'ContenSecurityTitle'} style={{float: 'left'}}>媒体类型</div>
                        <div style={{float: 'left', width: 140}} className={'ContenSecurityContent'}>
                            <Select
                                value={this.state.mediaType}
                                style={{width: '100%'}}
                                placeholder={"请选择"}
                                allowClear
                                onChange={(e) => {
                                    this.state.mediaType = e;
                                    this.TypeChange();
                                }}>
                                <Option value={2}>公众号</Option>
                                <Option value={3}>微博</Option>
                                <Option value={5}>抖音</Option>
                            </Select></div>
                    </div>
                    <div style={{float: 'left', paddingLeft: 10, display: "flex", alignItems: "center"}}>
                        <div className={'ContenSecurityTitle'} style={{float: 'left'}}>所属部门</div>
                        <div style={{float: 'left', width: 140}} className={'ContenSecurityContent'}>
                            <div>
                                <Select className={'ContenSecurityContent'}
                                        value={this.state.depart}
                                        style={{width: '100%'}}
                                        placeholder={"请选择"}
                                        allowClear
                                        onChange={(e) => {
                                            this.state.depart = e;
                                            this.TypeChange();
                                        }}>
                                    {/*<Option value={null}>请选择</Option>*/}
                                    {this.state.departAllList.map((item, i) => {
                                        return (
                                            <Option key={i} value={item.id}>{item.name}</Option>
                                        )
                                    })}
                                </Select>
                            </div>
                        </div>
                    </div>

                </div>
                <div style={{float: 'left', paddingLeft: 10,}}>
                    <div style={{height: 32, marginTop: 6}}>
                        <Search className={'ContenSecurityTitle'}
                                placeholder="请输入关键字"
                                enterButton="查询"
                                size="default"
                                value={this.state.searchText}
                                onChange={(e) => {
                                    this.setState({
                                        searchText: e.target.value
                                    });
                                }}
                                onSearch={value => {
                                    this.TypeChange();
                                }}
                        />
                    </div>
                </div>
                <div style={{float: 'left',}} className={'ContenSecurityTitle'}>
                    <Button onClick={() => {
                        this.revert()
                    }} type="primary">重置</Button>
                </div>

                <div style={{float: 'left',}} className={'ContenSecurityTitle'}>
                    <Button onClick={() => {
                        this.exportExcel()
                    }} type="primary">导出表格</Button>
                </div>
                <div style={{clear: 'both'}}/>
            </div>
        )
    }

    getTitle(record){
        let title;
        let sensitiveWords = '';
        record.sensitiveWordList && record.sensitiveWordList.length > 0 && record.sensitiveWordList.forEach((item, i) => {
            sensitiveWords = sensitiveWords + item.oldStr + (i === record.sensitiveWordList.length - 1 ? '' : '、')
        });
        let signWords = sensitiveWords.split('、');
        if (signWords && signWords.length > 0) {
            title = utils.filtion(signWords, "<div style='overflow: hidden;text-overflow: ellipsis;white-space: nowrap;'>" + record.title + "</div>").value;
        }else{
            title ="<div style='overflow: hidden;text-overflow: ellipsis;white-space: nowrap;'>" + record.title + "</div>";
        }
        return title;
    }

    //渲染内容
    renderContent() {
        let titleKeyList =
            [{
                key: 'key',
                titleName: '序号',
                ellipsis: true,
                width: 60,
                render: (text, record, index) => {
                    return (
                        <div title={(index + 1) + (this.state.page - 1) * (this.state.size)} style={{
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap'
                        }}>
                            {(index + 1) + (this.state.page - 1) * (this.state.size)}
                        </div>
                    )
                }
            }, {
                key: 'title',
                titleName: '文章标题',
                ellipsis: true,
                width: 400,
                render: (text, record) => {
                    return (
                        <div title={record.title} style={{
                            cursor: "pointer"
                        }} onClick={() => {
                            this.onClickItemReview(record)
                        }} dangerouslySetInnerHTML={{__html: this.getTitle(record)}} />
                    )
                }
            },
                {
                    key: 'mediaName',
                    titleName: '所属媒体',
                    ellipsis: true,
                    width:120,
                },
                {
                    key: 'status',
                    titleName: '媒体类型',
                    ellipsis: true,
                    width:100,
                    render: (text, record, index) => {
                        let iconType = '';
                        let title = '';
                        if (record.mediaType === 2) {
                            iconType = 'weChat';
                            title = "公众号";
                        } else if (record.mediaType === 3) {
                            iconType = 'microBlog';
                            title = "微博";
                        } else if (record.mediaType === 5) {
                            iconType = 'tiktok';
                            title = "抖音";
                        }
                        return (<div>
                                <TitleIcon title={title} iconType={iconType}/>
                            </div>

                        )
                    }
                },
                {
                    key: 'deptName',
                    titleName: '所属部门',
                    ellipsis: true,
                    width:120,
                },
                {
                    key: 'look',
                    titleName: '敏感词',
                    ellipsis: true,
                    render: (text, record, index) => {
                        let sensitiveWord = '';
                        record.sensitiveWordList && record.sensitiveWordList.length > 0 && record.sensitiveWordList.forEach((item, i) => {
                            sensitiveWord = sensitiveWord + item.oldStr + (i === record.sensitiveWordList.length - 1 ? '' : '、')
                        });
                        return (
                            <div title={sensitiveWord} style={{
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap'
                            }}>
                                {sensitiveWord}
                            </div>
                        )
                    }
                }, {
                key: 'account',
                titleName: '账号',
                ellipsis: true,
                width:130,
            },
                {
                    key: 'checkTime',
                    titleName: '监测时间',
                    width:180,
                    ellipsis: true,
                    render: (text, record, index) => {
                        return (
                            <div style={{
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap'
                            }}>
                                {text ? utils.formatDate(text) : ''}
                            </div>
                        )
                    }
                }];
        let height = window.innerHeight - 275;
        return (
            <div id={"systemDetection"} style={{padding: "0px 20px"}}>
                <Scrollbars
                    autoHeight
                    autoHide
                    autoHeightMax={height}
                >
                    <CustomTable
                        dataSource={this.state.dataSource}
                        titleKeyList={titleKeyList}
                        defineStyle={{paddingTop: 10, backgroundColor: "#fff"}}
                        pagination={false}
                    /></Scrollbars>
                <Divider style={{display: this.state.dataSource.length ? "block" : "none"}}/>
                <div style={{
                    padding: "16px 10px",
                    display: "flex",
                    justifyContent: "flex-end",
                    backgroundColor: "#ffffff",
                    borderRadius: "0 0 5px 5px"
                }}>
                    <Pagination
                        onChange={(page, pageSize) => {
                            this.paginationChange(page, pageSize)
                        }}//页码改变回调
                        onShowSizeChange={(page, pageSize) => {
                            this.state.hideOnSinglePage = false;
                            this.paginationChange(page, pageSize)
                        }}//每页条数改变回调
                        defaultCurrent={1}
                        defaultPageSize={10}
                        total={this.state.totalElements}
                        showTotal={total => `共${total}条`}
                        current={this.state.page}
                        pageSize={this.state.size}
                        showSizeChanger
                        showQuickJumper
                        hideOnSinglePage={this.state.hideOnSinglePage}
                    />
                </div>
                <style>{`#systemDetection .ant-divider-horizontal{margin: 10px 0px 0px 0px;}`}</style>
            </div>
        )
    }


    //获取系统检测列表
    getSystemSensitiveCheckListQuery() {
        let body = {
            page: this.state.page - 1,
            size: this.state.size,
            startDate: this.state.startDate ? this.state.startDate.format(' YYYY-MM-DD') + ' 00:00:00' : "",
            endDate: this.state.endDate ? this.state.endDate.format(dateFormat) + ' 23:59:59' : "",
            search: encodeURIComponent(this.state.searchText),
            deptId: this.state.depart || -1,
            mediaType: this.state.mediaType || -1
        };
        this.Action.getSystemSensitiveCheckListQuery(body, (data) => {
            let _data = data && data.data;
            let hideOnSinglePage = true;
            let totalElements = 0;
            let dataSource = [];
            if (_data && _data.content && _data.content.length) {
                dataSource = _data.content;
                totalElements = _data.totalElements;
                hideOnSinglePage = false;
            }
            this.setState({
                dataSource,
                totalElements,
                hideOnSinglePage
            }, () => {
                $('.ant-pagination-options-quick-jumper').find('input').val('')
            })
        })
    }

    //筛选项改变
    TypeChange() {
        this.state.page = 1;
        this.getSystemSensitiveCheckListQuery()
    }


    //重置
    revert() {
        this.state.page = 1;
        this.state.startDate = null;//开始时间
        this.state.endDate = null;//结束时间
        this.state.depart = undefined;//所属部门
        this.state.mediaType = undefined; //媒体类型
        this.state.searchText = '';//搜索的文字
        this.getSystemSensitiveCheckListQuery();
    }

    onClickItemReview(record) {
        let sensitiveWord = '';
        record.sensitiveWordList && record.sensitiveWordList.length > 0 && record.sensitiveWordList.forEach((item, i) => {
            sensitiveWord = sensitiveWord + item.oldStr + (i === record.sensitiveWordList.length - 1 ? '' : '、')
        });
        let signWords = sensitiveWord.split('、');
        let type = record.mediaType;
        if (type === 2) {
            //微信预览
            if (record && record.resourceId) {
                this.Action.getWechatDangerDetails(record.resourceId, (data) => {
                    let _data = data;
                    if (_data) {
                        let parms = {
                            title: _data.title,
                            summary: _data.summary,
                            content: _data.content,
                            titlePic: _data.titlePic,
                            author: _data.author,
                            updateDate: new Date(_data.statDate),
                            url: _data.link,
                            mediaName: _data.mediaName
                        };
                        this.WeChatReview.show('', '', signWords, parms)
                    } else {
                        message.error("该条数据已被删除,无法查看详情");
                    }
                });
            }
        } else if (type === 3) {
            if (record.resourceId) {
                //微博预览
                this.Action.getWeiBoDangerDetails(record.resourceId, (data) => {
                    let _data = data;
                    if (_data) {
                        let reviewParms = {
                            updateDate: utils.formatDate(_data.createdAt),//内容
                            content: _data.text,
                            picUrls: _data.picUrls,
                            publishUrl: _data.shareUrl
                        };
                        this.MicroBlogReview.show(reviewParms, signWords)
                    } else {
                        message.error("该条数据已被删除,无法查看详情");
                    }
                });
            }
        } else if (type === 5) {
            if (record.resourceId) {
                //抖音预览
                this.Action.getDouyinDangerDetails(record.resourceId, (data) => {
                    let _data = data;
                    if (_data) {
                        let reviewParms = {
                            title: _data.title,
                            titlePic: _data.cover,
                            updateDate: _data.collecTime,
                            author: _data.author,
                            videoUrl: _data.videoUrl,
                            videoShareUrl: _data.shareUrl
                        };
                        this.TiktokReview.show(reviewParms, signWords)
                    } else {
                        message.error("该条数据已被删除,无法查看详情");
                    }
                });
            }
        }
    }


    //导出系统检测表格
    exportExcel() {
        let startDate = this.state.startDate ? this.state.startDate.format(' YYYY-MM-DD') + ' 00:00:00' : '';
        let endDate = this.state.endDate ? this.state.endDate.format(dateFormat) + ' 23:59:59' : '';
        let searchText = this.state.searchText ? encodeURIComponent(this.state.searchText) : '';
        let url;
        let depart = this.state.depart ? this.state.depart : '-1';
        if (depart) {
            url = this.Action.getContentSecurityExcel + '?deptId=' + depart;
        }
        if (startDate) {
            url = url + '&startDate=' + startDate + '&endDate=' + endDate
        }
        if (searchText) {
            url = url + '&searchText=' + searchText
        }
        this.request({
            url, method: "downloadGet", contentType: 'json'
        });
    }

    //页码发生改变的时候
    paginationChange(page, pageSize) {
        this.state.page = page;
        this.state.size = pageSize;
        this.getSystemSensitiveCheckListQuery();
    }


}